<template>
	<br />
	<div class="has-text-centered">
		<img src="@/assets/images/skill-assessment/icons/medal.svg" class="mb-5"/>
		<div class="bold-text is-size-4">
			You Passed! Great Job.
		</div>
		<div class="is-size-6" v-if="isRealTechnician">
			Your skills request has been sent to the admin. You will be notified when it is approved.
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
	data () {
		return {
			isRealTechnician: false
		}
	},
	mounted () {
		try {
			this.isRealTechnician = document.getElementById('server-real-technician-context')?.innerText !== null;
		} catch (error) {
			
		}
	}
})
</script>

<style scoped>

</style>
